import { Component, input } from '@angular/core';
import { FlooriIconComponent } from '../floori-icon';

@Component({
    selector: 'floori-form-field',
    standalone: true,
    imports: [FlooriIconComponent],
    templateUrl: './floori-form-field.component.html',
    styleUrl: './floori-form-field.component.scss'
})
export class FlooriFormFieldComponent {
    label = input.required<string>();
    required = input<boolean>(false);
    errors = input<string[]>([]);
    showLabel = input<boolean>(false);
    showErrorIcon = input<boolean>(true);
    errorPosition = input<'left' | 'right'>('left');
}
